module.exports = __webpack_public_path__ + "static/media/31_tn.f354254e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/31_tn.jpg
// module id = 519
// module chunks = 0